import { render, staticRenderFns } from "./AssetButton.vue?vue&type=template&id=1866af26"
import script from "./AssetButton.vue?vue&type=script&lang=js"
export * from "./AssetButton.vue?vue&type=script&lang=js"
import style0 from "./AssetButton.vue?vue&type=style&index=0&id=1866af26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports